import { Component, OnInit, HostListener, AfterViewInit, OnDestroy, ViewEncapsulation, ViewChild, DoCheck, ChangeDetectorRef } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { UserDetailsService } from '../services/user-details.service';
import { EmitterService } from '../services/emitter.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import * as _ from 'underscore';
import { mapMobFooterRibbonlocation, mapSearchNonStickylocation } from '../shared/utility/config';
import { Location } from '@angular/common';
import PerfectScrollbar from 'perfect-scrollbar';
import { SlotGamesSearchComponent } from '../lobby/slot-games-search/slot-games-search.component';
import { ProfileSettingService } from '../services/profile-setting.service';
import { Subject } from 'rxjs';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { takeUntil } from 'rxjs/operators';
import { BonusService } from '../app-myaccount/bonuses/services/bonus.service';
@Component({
  selector: 'app-footerstickynav',
  templateUrl: './footerstickynav.component.html',
  styleUrls: ['./footerstickynav.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class FooterstickynavComponent implements OnInit, AfterViewInit, OnDestroy, DoCheck {
  isUserLoggedIn: boolean = false;
  disableActivatedMenu;
  siteUrlPath: string = environment.siteUrl;
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;
  mediaPath = environment.mediaPath;
  webisteCode = environment.website_code;
  userTotalBalance;
  userCurrencySymbol;
  langCode;
  mobFooterRibbon;
  searchFilters = false;
  showSearchFilter = false;
  gameWindow = false;
  isToShowNavPanel: boolean = false;
  selectedGames = null;
  searchInput;
  searchItemsLimit: any;
  searchItemsLimitValue: any;
  sortedGameData: any;
  isRealUser: boolean;
  userDetail;
  cashBalance;
  isVerifiedSkelton: boolean = true;
  dynamicHrefPath;
  searchClicked = false;
  
  
  userCashBalance;
  userBonusBalance;
  activeFooterTab;
  destroy$: Subject<boolean> = new Subject<boolean>();

  @ViewChild("slotGamesSearch")
  public slotsGamesSearchComp: SlotGamesSearchComponent;
  isCountryAllowed: any;

  @HostListener("window:scroll", ["$event"]) onWindowScroll() {
    if (!this.disableActivatedMenu && !this.showSearchFilter && !this.searchFilters) {
      this.disableActivatedMenu = true;
      // this.switchMenuToggle(false);
    }

    if ((($(window).scrollTop() >= 75 && $("body").hasClass("scrollUp"))
      || ($(window).scrollTop() >= 400 && $("body").hasClass("scrollDown"))) && this.mobFooterRibbon
    ) {
      $(".mob_footer_ribbon, body").addClass("mob_footer_ribbon--show");
    } else {
      $(".mob_footer_ribbon, body").removeClass("mob_footer_ribbon--show");
    }
  }

  constructor(
    private utils: Utility,
    public userService: UserDetailsService,
    private emitter: EmitterService,
    private router: Router,
    private location: Location,
    private profileSettingService: ProfileSettingService,
    private pnpService: PnpZimplerService,
    private bonusService: BonusService,
    private cdf:ChangeDetectorRef

  ) {
        this.userService.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.cashBalance = this.userService.getUserCashBalance();
            this.checkWithdrawal();
    });

    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
        this.isUserLoggedIn = loginStatus;  
        this.userCurrencySymbol = this.userService.getUserCurrencySymbol();
        this.userTotalBalance = this.userService.getUserTotalBalance();
      }
    );

    this.emitter.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    })

    this.langCode = localStorage.getItem('langCode');
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
      this.showMobFooterRibbon();
      this.searchNonSticky();
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.showMobFooterRibbon();
        this.searchNonSticky();
        if (window.location.pathname.includes("gameplay")) {
          // this.switchMenuToggle(false);
          this.gameWindow = true;
        } else {
          this.gameWindow = false;
        }
        this.utils.setDynamicUrlHref();
        this.dynamicHrefPath = this.utils.getDynamicUrlHref();
      }
    });

    this.userService.userCashBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(cashBalance => {
      this.userCashBalance=this.userService.getUserCashBalance();
    });

    this.userService.userBonusBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(bonusBalance => {
      this.userBonusBalance=this.userService.getUserBonusBalance();
    })

    this.userService.userTotalBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe((userTotalbalance)=>{
      this.userTotalBalance=userTotalbalance;
    });

    this.userCashBalance = this.userService.getUserCashBalance();
    this.userBonusBalance = this.userService.getUserBonusBalance();

    this.emitter.toggleNavPanel$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isToShowNavPanel = data;
    });
    this.emitter.showSearchBar$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.searchClicked = data;
    });
  }

  ngOnInit() {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.utils.setDynamicUrlHref();
    this.dynamicHrefPath = this.utils.getDynamicUrlHref();
  }
  ngDoCheck(): void {
    this.checkFooterTabActive();
  }
  checkFooterTabActive(){
    if(this.searchClicked){
      this.activeFooterTab = 'search'
    }else if(location.pathname.includes('/casino') || location.pathname == '/'+this.langCode){
      this.activeFooterTab = 'casino'
    }else if(location.pathname.includes('/promotions') || location.pathname == '/'+this.langCode){
      this.activeFooterTab = 'promotions'
    }else{
      this.activeFooterTab = "";
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!window.location.pathname.includes("gameplay")) {
        // this.switchMenuToggle(true);
      }
    });

    this.userCurrencySymbol = this.userService.getUserCurrencySymbol();
    this.userTotalBalance = this.userService.getUserTotalBalance();
    // const ps = new PerfectScrollbar('.hamburger_menu--main-innermenu');
    this.cdf.detectChanges()
  }
  searchGames(searchValue) {
    this.selectedGames = null;
    this.searchItemsLimit = this.searchItemsLimitValue;
    if (searchValue == "") {
      return;
    }
    if (this.sortedGameData != null && this.sortedGameData.length > 0) {
      this.selectedGames = _.filter(this.sortedGameData, function (game) {
        return game['name'].toLowerCase().indexOf(searchValue.toLowerCase()) != -1 || game['vendorDisplayName'].toLowerCase().indexOf(searchValue.toLowerCase()) != -1;
      });
    } else {
      this.selectedGames = [];
    }
    setTimeout(() => {
      if ($('.search_block--wrap').length > 0) {
        const ps = new PerfectScrollbar('.search_block--wrap');
      }
    }, 100)
  }
  doLogout() {
    this.userService.doLogout();
    this.isToShowNavPanel = false;
    $("body").removeClass("hiddenOverflow");
  }
 goToHomePage(){
  this.goToTop();
  this.emitter.broadcastRouteChange(false);
  this.utils.disablescrollOnRegistrationPageOpend();
  this.emitter.broadCastIsGameModal(false);
 }
 goToCasinoTabs(){
  this.searchClicked=false;
  this.utils.disablescrollOnRegistrationPageOpend();
  this.emitter.broadcastRouteChange(false);
  this.goToTop();
  this.emitter.broadCastIsGameModal(false);
 }
  menuToggle() {
    this.emitter.broadcastRouteChange(false);
    this.emitter.broadCastIsGameModal(false);
    /*- close step two -*/
    //remove query params and close step two in the background, if it is opened 
    $('#navPanelToggle').show();
    //Removing/commeting out below code as a part of ESI-5650
    // if(!this.isToShowNavPanel){
    //   this.utils.removeParam({'page': null});
    //   this.emitter.broadcastRouteChange(false);
    // }
    /*- close step two -*/
    this.isToShowNavPanel = !this.isToShowNavPanel;
    this.emitter.broadCastToggleNavPanel(this.isToShowNavPanel);
    $(".dropdown-section--btn").parent().find("ul").removeClass("expanded");
    $(".dropdown-section--btn").find("i").removeClass("rotate");
  }
  closeSearch(): void {
    this.selectedGames = null;
    this.searchInput = undefined;
  }
  closeMenu() {
    this.isToShowNavPanel = false;
    $("body").removeClass("hiddenOverflow");
  }
  // activateCustomScroll() {
  //   $('.hamburger_menu--main-innermenu').animate({
  //     scrollTop: 1
  //   }, 100);
  // }
  // switchMenuToggle(bool) {
  //   if (bool) {
  //     $("body").addClass("footer-sticky_nav--top-show");
  //   } else {
  //     $("body").removeClass("footer-sticky_nav--top-show");
  //     $("body").removeClass("search_filters--open");
  //     this.searchFilters = false;
  //   }
  // }

  navigateTo(event, path) {
    event.preventDefault();
    if(path === 'zimpler_register') {
      if(this.userService.checkZimplerDepositOpen()){
        this.pnpService.openZimplerDeposit()
      }
    } else if(path === "login" && this.isCountryAllowed===1){
      this.pnpService.openZimplerLogin()
    } else if(path == "registration"){
      this.emitter.broadCastXSaleRegistration(true)
    }
    else{
      if(path==='myaccount') this.bonusService.broadRefreshEligibleBonus(true);
      this.router.navigate([this.langCode + '/' + path]);
    }
    this.goToTop();
    // this.switchMenuToggle(false);
    this.closeGameModalPopup();
    this.closeMenu();
  }

  navigateToRegistration(){
    if(this.isCountryAllowed == 1){
      this.pnpService.openZimplerDeposit();
    }else{
      this.router.navigate([this.langCode+'/register']);
    }
  }
  closeGameModalPopup() {
    if ($('.mobileGameModal:visible').length > 0) {
      const gameModalId = $('.mobileGameModal:visible').attr("class").split(' ')[1];
      this.utils.closeModal(gameModalId);
    }
  }

  // Close game modal popup in mobile device click Login link in PNP
  linkLoginPnp(){
    this.emitter.broadCastIsGameModal(false);
  }

  doDeposit(event) {
    event.preventDefault();
    if(!this.userService.checkIsPNPUser()){
      this.emitter.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    } else {
      this.pnpService.openZimplerDeposit()
    }
    // this.emitter.broadcastModalState({ name:"paymentModal",state:"open", cashierType: "deposit" });
    this.closeMenu();
  }

  withdraw() {
    this.emitter.broadcastModalState({ name:"paymentModal",state:"open", cashierType: "withdrawal" });
    this.closeMenu();
  }


  // Check Withdrawals
  checkWithdrawal() {
    Promise.resolve(this.profileSettingService.getProfileData(true)).then(profileData => {
      this.userService.setUserCountry(profileData["country"]);
      this.userDetail = this.userService.getUserProfileDetails();
      this.isRealUser = this.userDetail && this.userDetail.userStatus === "real" ? true : false;
      this.isVerifiedSkelton = false;
    }
    );
  }

  goToTop() {
    this.emitter.broadCastShowSearchBar(false);
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    
  }

  openSearch(){
   if(!location.pathname.includes('/login') && !location.pathname.includes('/myaccount') && !location.pathname.includes('/page')){
    this.searchClicked = !this.searchClicked;
    if(this.searchClicked){
      // this.goToTop();
      this.utils.showSearchBar();
      this.emitter.broadCastIsGameModal(false);
    }else{
      this.emitter.broadCastShowSearchBar(false);  
    }
   }
  }
  
  // Open Quick login modal with query param
  openQuickLogin() {
    // this.switchMenuToggle(false);
    this.router.navigate([], { queryParams: { "quicklogin": true }, queryParamsHandling: "merge" });
  }

  showMobFooterRibbon() {
    if (this.utils.isUserLoggedIn()) {
      this.mobFooterRibbon = false;
    } else {
      for (let i = 0; i < mapMobFooterRibbonlocation.length; i++) {
        if (this.location.path() === "" || this.location.path() === "/" + this.langCode
          || this.location.path().includes(mapMobFooterRibbonlocation[i])) {
          this.mobFooterRibbon = true;
          break;
        } else {
          this.mobFooterRibbon = false;
        }
      }
    }
  }

  searchNonSticky() {
    let fullLocationPath=this.location.path();
    let locationPath="";
    // Modified Code to match location even though it has Query Params
    if(fullLocationPath.indexOf("?")>0){
      // we are Only considering the route before "?" as location path to match in our Config Array
      locationPath=fullLocationPath.split("?")[0];
    }else{
      locationPath=fullLocationPath;
    }
    
    for (let i = 0; i < mapSearchNonStickylocation.length; i++) {
      if (((locationPath === "" || locationPath === "/" + this.langCode) && this.utils.isUserLoggedIn())
        || locationPath.includes(mapSearchNonStickylocation[i])) {
        this.showSearchFilter = true;
        this.searchFilters = true;
        // $("body").addClass("search_filters--open");
        break;
      } else {
        // $("body").removeClass("search_filters--open");
        this.showSearchFilter = false;
        this.searchFilters = false;
      }
    }

    setTimeout(() => {
      if (this.slotsGamesSearchComp !== undefined) {
        this.slotsGamesSearchComp.closeSearch();
      }
    });
  }

  setSlotGames(gameData) {
    this.sortedGameData = gameData;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
